import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext"; // 언어 Context 사용
import {
  FiCreditCard,
  FiSettings,
  FiHelpCircle,
  FiUser,
  FiChevronLeft,
  FiChevronRight,
  FiFolder,
} from "react-icons/fi";
import "./SideBar.css";

// 다국어 지원을 위한 번역 객체
const translations = {
  ko: {
    user: "사용자",
    noEmail: "이메일 정보 없음",
    subscriptionInfo: "구독 정보",
    plan: "플랜:",
    status: "상태:",
    nextBilling: "다음 결제일:",
    price: "금액:",
    manageSubscription: "구독 관리",
    myAccount: "내 계정",
    paymentManagement: "결제 관리",
    settings: "설정",
    help: "도움말",
    dashboard: "대시보드",
    service: "아이디어2마켓 주식회사",
    version: "idea2m.com",
  },
  en: {
    user: "User",
    noEmail: "No email information",
    subscriptionInfo: "Subscription Information",
    plan: "Plan:",
    status: "Status:",
    nextBilling: "Next Billing:",
    price: "Price:",
    manageSubscription: "Manage Subscription",
    myAccount: "My Account",
    paymentManagement: "Payment Management",
    settings: "Settings",
    help: "Help",
    dashboard: "Dashboard",
    service: "I2M's R&D Service",
    version: "v1.0.0",
  },
  ja: {
    user: "ユーザー",
    noEmail: "メール情報なし",
    subscriptionInfo: "サブスクリプション情報",
    plan: "プラン:",
    status: "ステータス:",
    nextBilling: "次回請求日:",
    price: "金額:",
    manageSubscription: "サブスクリプション管理",
    myAccount: "マイアカウント",
    paymentManagement: "支払い管理",
    settings: "設定",
    help: "ヘルプ",
    dashboard: "ダッシュボード",
    service: "I2Mの研究開発サービス",
    version: "v1.0.0",
  },
  "zh-CN": {
    user: "用户",
    noEmail: "无电子邮件信息",
    subscriptionInfo: "订阅信息",
    plan: "计划:",
    status: "状态:",
    nextBilling: "下次计费日期:",
    price: "价格:",
    manageSubscription: "管理订阅",
    myAccount: "我的账户",
    paymentManagement: "支付管理",
    settings: "设置",
    help: "帮助",
    dashboard: "仪表板",
    service: "I2M研发服务",
    version: "v1.0.0",
  },
  "zh-TW": {
    user: "用戶",
    noEmail: "無電子郵件信息",
    subscriptionInfo: "訂閱信息",
    plan: "計劃:",
    status: "狀態:",
    nextBilling: "下次計費日期:",
    price: "價格:",
    manageSubscription: "管理訂閱",
    myAccount: "我的賬戶",
    paymentManagement: "支付管理",
    settings: "設置",
    help: "幫助",
    dashboard: "儀表板",
    service: "I2M研發服務",
    version: "v1.0.0",
  },
  it: {
    user: "Utente",
    noEmail: "Nessuna informazione email",
    subscriptionInfo: "Informazioni sull'abbonamento",
    plan: "Piano:",
    status: "Stato:",
    nextBilling: "Prossima fatturazione:",
    price: "Prezzo:",
    manageSubscription: "Gestisci abbonamento",
    myAccount: "Il mio account",
    paymentManagement: "Gestione pagamenti",
    settings: "Impostazioni",
    help: "Aiuto",
    dashboard: "Dashboard",
    service: "Servizio R&D di I2M",
    version: "v1.0.0",
  },
  fr: {
    user: "Utilisateur",
    noEmail: "Aucune information d'e-mail",
    subscriptionInfo: "Informations d'abonnement",
    plan: "Plan :",
    status: "Statut :",
    nextBilling: "Prochaine facturation :",
    price: "Prix :",
    manageSubscription: "Gérer l'abonnement",
    myAccount: "Mon compte",
    paymentManagement: "Gestion des paiements",
    settings: "Paramètres",
    help: "Aide",
    dashboard: "Tableau de bord",
    service: "Service R&D d'I2M",
    version: "v1.0.0",
  },
  de: {
    user: "Benutzer",
    noEmail: "Keine E-Mail-Informationen",
    subscriptionInfo: "Abonnementinformationen",
    plan: "Plan:",
    status: "Status:",
    nextBilling: "Nächste Abrechnung:",
    price: "Preis:",
    manageSubscription: "Abonnement verwalten",
    myAccount: "Mein Konto",
    paymentManagement: "Zahlungsverwaltung",
    settings: "Einstellungen",
    help: "Hilfe",
    dashboard: "Dashboard",
    service: "I2M F&E-Service",
    version: "v1.0.0",
  },
  es: {
    user: "Usuario",
    noEmail: "Sin información de correo electrónico",
    subscriptionInfo: "Información de suscripción",
    plan: "Plan:",
    status: "Estado:",
    nextBilling: "Próxima facturación:",
    price: "Precio:",
    manageSubscription: "Gestionar suscripción",
    myAccount: "Mi cuenta",
    paymentManagement: "Gestión de pagos",
    settings: "Configuración",
    help: "Ayuda",
    dashboard: "Panel",
    service: "Servicio de I+D de I2M",
    version: "v1.0.0",
  },
  ru: {
    user: "Пользователь",
    noEmail: "Нет информации об электронной почте",
    subscriptionInfo: "Информация о подписке",
    plan: "План:",
    status: "Статус:",
    nextBilling: "Следующий платеж:",
    price: "Цена:",
    manageSubscription: "Управление подпиской",
    myAccount: "Мой аккаунт",
    paymentManagement: "Управление платежами",
    settings: "Настройки",
    help: "Помощь",
    dashboard: "Панель управления",
    service: "Сервис R&D I2M",
    version: "v1.0.0",
  },
  pt: {
    user: "Usuário",
    noEmail: "Sem informações de e-mail",
    subscriptionInfo: "Informações de assinatura",
    plan: "Plano:",
    status: "Status:",
    nextBilling: "Próxima cobrança:",
    price: "Preço:",
    manageSubscription: "Gerenciar assinatura",
    myAccount: "Minha conta",
    paymentManagement: "Gerenciamento de pagamentos",
    settings: "Configurações",
    help: "Ajuda",
    dashboard: "Painel",
    service: "Serviço de P&D da I2M",
    version: "v1.0.0",
  },
  ar: {
    user: "المستخدم",
    noEmail: "لا توجد معلومات البريد الإلكتروني",
    subscriptionInfo: "معلومات الاشتراك",
    plan: "الخطة:",
    status: "الحالة:",
    nextBilling: "الفاتورة التالية:",
    price: "السعر:",
    manageSubscription: "إدارة الاشتراك",
    myAccount: "حسابي",
    paymentManagement: "إدارة الدفع",
    settings: "الإعدادات",
    help: "المساعدة",
    dashboard: "لوحة التحكم",
    service: "خدمة البحث والتطوير من I2M",
    version: "الإصدار 1.0.0",
  },
  hi: {
    user: "उपयोगकर्ता",
    noEmail: "कोई ईमेल जानकारी नहीं",
    subscriptionInfo: "सदस्यता जानकारी",
    plan: "योजना:",
    status: "स्थिति:",
    nextBilling: "अगली बिलिंग:",
    price: "कीमत:",
    manageSubscription: "सदस्यता प्रबंधित करें",
    myAccount: "मेरा खाता",
    paymentManagement: "भुगतान प्रबंधन",
    settings: "सेटिंग्स",
    help: "सहायता",
    dashboard: "डैशबोर्ड",
    service: "I2M का R&D सेवा",
    version: "v1.0.0",
  },
};

const SideBar = ({ userInfo, subscriptionInfo, collapsed, toggleCollapse }) => {
  // 언어 Context 사용
  const { currentLanguage } = useLanguage();

  // 현재 언어에 따른 텍스트 가져오기
  const getText = (key) => {
    return translations[currentLanguage]?.[key] || translations["en"][key];
  };

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <button
        className="toggle-sidebar"
        onClick={toggleCollapse || (() => setCollapsed(!collapsed))}
      >
        {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
      </button>

      <div className="sidebar-user">
        {!collapsed && (
          <div className="user-details">
            <h3>{userInfo?.name || getText("user")}</h3>
            <p>{userInfo?.email || getText("noEmail")}</p>
          </div>
        )}
      </div>

      {!collapsed && subscriptionInfo && (
        <div className="sidebar-section">
          <h4>{getText("subscriptionInfo")}</h4>
          <div className="subscription-info">
            <div className="info-row">
              <span className="info-label">{getText("plan")}</span>
              <span className="info-value">{subscriptionInfo.plan}</span>
            </div>
            <div className="info-row">
              <span className="info-label">{getText("status")}</span>
              <span className="info-value status-active">
                {subscriptionInfo.status}
              </span>
            </div>
            <div className="info-row">
              <span className="info-label">{getText("nextBilling")}</span>
              <span className="info-value">{subscriptionInfo.nextBilling}</span>
            </div>
            <div className="info-row">
              <span className="info-label">{getText("price")}</span>
              <span className="info-value">{subscriptionInfo.price}</span>
            </div>
            <button className="subscription-button">
              {getText("manageSubscription")}
            </button>
          </div>
        </div>
      )}

      <div className="sidebar-nav">
        {/*
        <a href="#" className="nav-item">
          <FiUser />
          {!collapsed && <span>{getText("myAccount")}</span>}
        </a>
        <a href="#" className="nav-item">
          <FiCreditCard />
          {!collapsed && <span>{getText("paymentManagement")}</span>}
        </a>
        <a href="#" className="nav-item">
          <FiSettings />
          {!collapsed && <span>{getText("settings")}</span>}
        </a>
        */}
        <Link to="/help" className="nav-item">
          <FiHelpCircle />
          {!collapsed && <span>{getText("help")}</span>}
        </Link>
        <Link to="/dashboard" className="nav-item">
          <FiFolder />
          {!collapsed && <span>{getText("dashboard")}</span>}
        </Link>
      </div>

      {!collapsed && (
        <div className="sidebar-footer">
          <p>{getText("service")}</p>
          <p className="version">{getText("version")}</p>
        </div>
      )}
    </div>
  );
};

export default SideBar;
